import { PERILS_GET} from 'domain/types/perfil/perfil';
import {PerfilService} from 'domain/services/perfil/perfilService'
import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'

import { PerfilResponse } from 'domain/types/perfil/perfilResponse';
import { AppThunk } from '../../../utils/reducerUtil';

const _PerfilService = new PerfilService();

export function GetPerfilAtivos(sistemaID: number): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(PERILS_GET, DispatchType.LOADING, undefined, undefined,
        () => { dispatch(GetPerfilAtivos(sistemaID)) }))
        
        const asyncResponse = await _PerfilService.GetAtivos(sistemaID)
        if (ResponseValid(asyncResponse)) {
            const paged = (asyncResponse as PerfilResponse[])
            dispatch({
                payload: paged,
                type: PERILS_GET
            })
        }
    };
}
